import {useIntl} from 'react-intl'
import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import NothingToShow from '../../captable-management/components/NothingToShow'

export const EarlyInvitees = ({invitees}: {invitees: any[]}) => {
  const {formatMessage} = useIntl()

  return (
    <div className='mt-4 p-6 bg-white rounded-2' style={{height: '500px'}}>
      <h6 className='mb-4'>
        {formatMessage({id: `Confirmed Invitees `})}
        <span className={invitees.length === 0 ? 'd-none' : ''}>({invitees.length})</span>
      </h6>

      <div className='py-4'>
        <ul className='p-0' style={{maxHeight: '450px', overflowY: 'auto'}}>
          {invitees.length === 0 ? (
            <div style={{height: '420px'}}>
              <NothingToShow />
            </div>
          ) : (
            invitees.map((inviteUser: any, index: number) => (
              <li
                key={index}
                className='d-flex justify-content-start align-items-center gap-2 mt-4'
              >
                <DisplayImage
                  imgName={`${inviteUser?.user?.profileImage}`}
                  alt='Profile Image'
                  height='30px'
                  width='30px'
                  fit='contain'
                  className='rounded-2'
                />
                <p className='m-0'>
                  {formatMessage({
                    id: `${inviteUser?.user?.firstName} ${inviteUser?.user?.lastName}`,
                  })}
                </p>
              </li>
            ))
          )}
        </ul>
      </div>
    </div>
  )
}
